import { create } from "zustand";
import { persist } from "zustand/middleware";

type SessionStore = {
	session: Session | null;
	setSession: (session: Session | null) => void;
};

const useSession = create<SessionStore>()(
	persist(
		set => ({
			session: null,
			setSession: (session: Session | null) => set({ session }),
		}),
		{ name: "AuthSession" }
	)
);

export default useSession;
